<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 68 218"
        xml:space="preserve"
    >
        <path
            fill="#ee2738"
            class="st0"
            d="M34.77,167.52c0.45,6.53,4.58,10.64,10.83,11.77c1.28,0.23,2.55,0.5,3.85,0.49c0.46,0.17,0.94,0.05,1.41,0.09
	c1.14,0.05,2.28-0.11,3.41,0.08c0.51,0.17,0.91-0.31,1.41-0.23c0.39-0.22,0.85,0.02,1.24-0.18c3.42-0.22,6.69-1.18,9.97-2.07
	c0.99-0.27,1.05,0.05,1.05,0.85c-0.02,9.76-0.02,19.51,0.01,29.27c0,0.79-0.31,1.16-0.96,1.4c-3.2,1.17-6.45,2.12-9.83,2.67
	c-3.03,0.49-6.07,0.93-9.14,0.98c-0.39,0.17-0.8,0.05-1.2,0.09c-0.47,0-0.94,0-1.41,0c-0.65,0.06-1.32-0.14-1.96,0.12
	c-2.96,0-5.92,0-8.88,0c-2.49-0.27-4.95-0.55-7.39-1.25c-9.97-2.85-17.42-8.75-22.45-17.83c-2.77-5.01-4.09-10.35-4.5-16
	c-0.09-1.18,0.07-2.38-0.22-3.55c0-47.03,0-94.06,0-141.08c0.79-1.32,1.98-2.29,3.1-3.3c0.71-0.64,1.44-1.26,2.11-1.95
	c3.53-3.64,7.27-7.06,10.9-10.6c4.39-4.29,8.84-8.53,13.27-12.78c1.6-1.54,3.09-3.23,4.95-4.49c0.08,0,0.16,0,0.24,0
	c0.23,0.46,0.11,0.94,0.11,1.42c0.01,54.85,0.01,109.69,0.01,164.54C34.73,166.49,34.61,167.01,34.77,167.52z"
        />
    </svg>
</template>
